'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogEventSelectedOptions = exports.LogEvent = exports.LogName = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = logNavigation;
exports.logNavigationPopup = logNavigationPopup;
exports.logNavigationSSO = logNavigationSSO;
exports.logLanguage = logLanguage;
exports.createEventSelectedOption = createEventSelectedOption;
exports.getLogNameByRouterConst = getLogNameByRouterConst;
exports.getLogNameByPathname = getLogNameByPathname;
exports.logRedirect = logRedirect;

var _config = require('./../config');

var _config2 = _interopRequireDefault(_config);

var _createLoginClient = require('./createLoginClient');

var _createLoginClient2 = _interopRequireDefault(_createLoginClient);

var _Error = require('./Error');

var _Router = require('./Router');

var _Cookie = require('./Cookie');

var _log = require('../redux/modules/log');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogName = exports.LogName = {
  Addresses: 'Addresses',
  AllProviderList: 'AllProviderList',
  ApproveAgreements: 'EulaAgreement',
  Authorization: 'Authorization',
  AuthorizationError: 'AuthorizationError',
  AuthorizationExpired: 'AuthorizationExpired',
  AuthorizationNow: 'AuthorizationNow',
  AuthorizationOptions: 'AuthorizationOptions',
  AuthorizationSSOSuccess: 'AuthorizationSSOSuccess',
  AutoLogin: 'auto-login',
  ConfirmForgotPassword: 'ConfirmForgotPassword',
  ConnectWithAmazon: 'ConnectWithAmazon',
  ConnectWithApple: 'ConnectWithApple',
  ConnectWithFacebook: 'ConnectWithFacebook',
  ConnectWithGoogle: 'ConnectWithGoogle',
  ContactUs: 'ContactUs',
  ContactUsFeedback: 'ContactUsFeedback',
  CreateAccount: 'CreateAccount',
  ErrorRetry: 'ErrorRetry',
  ExistingAccount: 'ExistingAccount',
  FirstTimeLogin: 'FirstTimeLogin',
  ForgotPassword: 'ForgotPassword',
  HelpInfo: 'HelpInfo',
  IOSReceiptLogin: 'IOSReceiptLogin',
  LinkAccount: 'LinkAccount',
  LinkExpired: 'LinkExpired',
  LinkIOSReceipt: 'LinkIOSReceipt',
  LinkOverDrive: 'LinkOverDrive',
  LinkSecureToken: 'LinkSecureToken',
  LinkSSOToken: 'LinkSSOToken',
  LoginEmail: 'LoginEmail',
  LoginOptions: 'LoginOptions',
  Logout: 'Logout',
  QRLogin: 'QrLogin',
  QRSignUp: 'QrSignUp',
  PreAuthorizedLink: 'PreAuthorizedLink',
  ProviderNotListed: 'ProviderNotListed',
  OverDriveLogin: 'OverDriveLogin',
  ResetPassword: 'ResetPassword',
  ResetPasswordConfirmation: 'ResetPasswordConfirmation',
  ResetPasswordExpired: 'ResetPasswordExpired',
  SignUpOptions: 'SignUpOptions',
  SpecialOffersAgreement: 'SpecialOffersAgreement',
  SSOLink: 'SSOLink',
  SSOLogin: 'SSOLogin',
  SSOProvider: 'SSOWeb',
  SwitchProvider: 'SwitchProvider',
  TopProviders: 'TopProviders',
  TrialExpired: 'TrialExpired',
  TV: 'TV',
  TVCodeForm: 'TVCodeForm',
  TVLoginSuccess: 'TVLoginSuccess',
  UserDeviceLogin: 'UserDeviceLogin',
  ValidateSSO: 'ValidateSSO',
  Version: 'Version',
  WebPlayerLinkAccount: 'WebPlayerLinkAccount',
  Welcome: 'Welcome',
  WhyAuthorize: 'WhyAuthorize',
  WhyStingrayAccount: 'WhyStingrayAccount',
  Amazon: 'Amazon',
  Apple: 'Apple',
  Facebook: 'Facebook',
  Google: 'Google',
  CreatePasswordAndLinkToProfile: 'CreatePasswordAndLink',

  NotFound: 404
};

var connectionMethodLogNamePage = [_Router.RouterConst.LoginOptions, _Router.RouterConst.LoginEmail, _Router.RouterConst.SignUpEmail, _Router.RouterConst.SignUpOptions];

var LogEvent = exports.LogEvent = {
  Language: 'Language',
  Navigation: 'Navigation',
  NavigationPopup: 'NavigationPopup',
  SSOWebPage: 'SSO'
};

var LogEventSelectedOptions = exports.LogEventSelectedOptions = {
  Attempts: 'Attempts',
  Fail: 'Fail',
  Success: 'Success',
  Trial: 'Trial'
};

function storeLogNavigation(eventName, source, destination, destinationTime, store) {
  if (store && (eventName === LogEvent.Navigation || eventName === LogEvent.NavigationPopup)) {
    (0, _log.saveLogNavigation)(destination, destinationTime, store);
    if (destination === LogName.ContactUs && source !== LogName.Addresses || destination === LogName.ProviderNotListed) {
      (0, _log.saveContactUsSource)(source, store);
    }
  }
}

function logNavigationEvent(source, destination, eventName, eventSelectedOption, log, auth, appInfo, store) {
  (0, _createLoginClient2.default)().then(function (loginClient) {
    var destinationTime = new Date().getTime();
    var timeInSec = (destinationTime - log.srcTime) / 1000;
    var event = {
      logNavigationEvents: [{
        source: source,
        event: eventName,
        destination: destination,
        productName: auth.productName,
        platform: auth.platform,
        deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm),
        eventTimestamp: destinationTime,
        thinkTimeSeconds: timeInSec,
        universalLoginFEVersion: appInfo.version,
        eventSelectedOption: eventSelectedOption,
        clientId: auth.clientId
      }]
    };
    if (auth.sessionId) {
      loginClient.log.logNavigationEvent({
        sessionId: auth.sessionId,
        languageTag: auth.lang,
        logNavigationEvents: (0, _stringify2.default)(event)
      }, { responseContentType: 'application/json' }).then(function () {
        storeLogNavigation(eventName, source, destination, destinationTime, store);
      }).catch(function (error) {
        (0, _Error.logError)(error.statusText);
        storeLogNavigation(eventName, source, destination, destinationTime, store);
      });
    } else {
      loginClient.log.logNavigationEventBeforeSession({
        languageTag: auth.lang,
        logNavigationEvents: (0, _stringify2.default)(event)
      }, { responseContentType: 'application/json' }).then(function () {
        storeLogNavigation(eventName, source, destination, destinationTime, store);
      }).catch(function (error) {
        (0, _Error.logError)(error.statusText);
        storeLogNavigation(eventName, source, destination, destinationTime, store);
      });
    }
  });
}

function logNavigation(source, destination, log, auth, appInfo, store) {
  logNavigationEvent(source, destination, LogEvent.Navigation, '', log, auth, appInfo, store);
}

function logNavigationPopup(source, destination, log, auth, appInfo, store) {
  logNavigationEvent(source, destination, LogEvent.NavigationPopup, '', log, auth, appInfo, store);
}

function logNavigationSSO(source, destination, eventSelectedOption, log, auth, appInfo, store) {
  logNavigationEvent(source, destination, LogEvent.SSOWebPage, eventSelectedOption, log, auth, appInfo, store);
}

function logLanguage(source, newLang, log, auth, appInfo) {
  var eventSelectedOption = 'Language;code:' + newLang;
  logNavigationEvent(source, '', LogEvent.Language, eventSelectedOption, log, auth, appInfo);
}

function createEventSelectedOption(eventOption, additionalParams, additionalParamsValues) {
  var additionalParamsStrings = '';

  if (additionalParams && additionalParamsValues) {
    if (additionalParams.length !== additionalParamsValues.length) {
      console.error('additionalParams and additionalParamsValues not the same length');
    } else {
      for (var index = 0; index < additionalParams.length; index += 1) {
        additionalParamsStrings += ';' + additionalParams[index] + ':' + additionalParamsValues[index];
      }
    }
  }
  return eventOption + additionalParamsStrings;
}

function getPathArray(pathname) {
  return pathname.split('/').filter(function (item) {
    return item !== '';
  });
}

function validPathname(pathname) {
  var paths = getPathArray(pathname.toLowerCase());
  var routerArray = (0, _keys2.default)(_Router.RouterConst).map(function (key) {
    return _Router.RouterConst[key].toLowerCase();
  });
  var value = paths.length > 0;
  paths.forEach(function (path) {
    // make an exception for the TV/Code pages
    if (path === _Router.RouterConst.TV || path === _Router.RouterConst.Code) {
      value = true;
    } else if (routerArray.indexOf(path) === -1) {
      value = false;
    }
  });
  return value;
}

function getLastPathName(path) {
  var pathname = getPathArray(path);
  return pathname[pathname.length - 1];
}

function getLogNameByRouterConst(name) {
  var result = void 0;
  switch (name) {
    case _Router.RouterConst.Addresses:
      result = LogName.Addresses;
      break;
    case _Router.RouterConst.AllProviders:
      result = LogName.AllProviderList;
      break;
    case _Router.RouterConst.ApproveAgreements:
      result = LogName.ApproveAgreements;
      break;
    case _Router.RouterConst.Authorization:
      result = LogName.Authorization;
      break;
    case _Router.RouterConst.AuthorizationError:
      result = LogName.AuthorizationError;
      break;
    case _Router.RouterConst.AuthorizationExpired:
      result = LogName.AuthorizationExpired;
      break;
    case _Router.RouterConst.AuthorizationNow:
      result = LogName.AuthorizationNow;
      break;
    case _Router.RouterConst.AuthorizationOptions:
      result = LogName.AuthorizationOptions;
      break;
    case _Router.RouterConst.AuthorizationSSOSuccess:
      result = LogName.AuthorizationSSOSuccess;
      break;
    case _Router.RouterConst.Communication:
      result = LogName.SpecialOffersAgreement;
      break;
    case _Router.RouterConst.ConfirmForgotPassword:
      result = LogName.ConfirmForgotPassword;
      break;
    case _Router.RouterConst.ContactUs:
      result = LogName.ContactUs;
      break;
    case _Router.RouterConst.ContactUsFeedback:
      result = LogName.ContactUsFeedback;
      break;
    case _Router.RouterConst.ErrorRetry:
      result = LogName.ErrorRetry;
      break;
    case _Router.RouterConst.ExistingAccount:
      result = LogName.ExistingAccount;
      break;
    case _Router.RouterConst.ForgotPassword:
      result = LogName.ForgotPassword;
      break;
    case _Router.RouterConst.LinkAccount:
      result = LogName.LinkAccount;
      break;
    case _Router.RouterConst.LoginEmail:
      result = LogName.LoginEmail;
      break;
    case _Router.RouterConst.LinkExpired:
      result = LogName.LinkExpired;
      break;
    case _Router.RouterConst.LoginOptions:
      result = LogName.LoginOptions;
      break;
    case _Router.RouterConst.QRLogin:
      result = LogName.QRLogin;
      break;
    case _Router.RouterConst.QRSignUp:
      result = LogName.QRSignUp;
      break;
    case _Router.RouterConst.ProviderNotListed:
      result = LogName.ProviderNotListed;
      break;
    case _Router.RouterConst.ResetPassword:
      result = LogName.ResetPassword;
      break;
    case _Router.RouterConst.ResetPasswordConfirmation:
      result = LogName.ResetPasswordConfirmation;
      break;
    case _Router.RouterConst.ResetPasswordExpired:
      result = LogName.ResetPasswordExpired;
      break;
    case _Router.RouterConst.SignUpEmail:
      result = LogName.CreateAccount;
      break;
    case _Router.RouterConst.SignUpOptions:
      result = LogName.SignUpOptions;
      break;
    case _Router.RouterConst.SwitchProvider:
      result = LogName.SwitchProvider;
      break;
    case _Router.RouterConst.TopProviders:
      result = LogName.TopProviders;
      break;
    case _Router.RouterConst.TrialExpired:
      result = LogName.TrialExpired;
      break;
    case _Router.RouterConst.TV:
    case _Router.RouterConst.Code:
      result = LogName.TV;
      break;
    case _Router.RouterConst.TVCodeForm:
      result = LogName.TVCodeForm;
      break;
    case _Router.RouterConst.TVLoginSuccess:
      result = LogName.TVLoginSuccess;
      break;
    case _Router.RouterConst.ValidateSSO:
      result = LogName.ValidateSSO;
      break;
    case _Router.RouterConst.Version:
      result = LogName.Version;
      break;
    case _Router.RouterConst.Welcome:
      result = LogName.Welcome;
      break;
    case _Router.RouterConst.Amazon:
      result = LogName.Amazon;
      break;
    case _Router.RouterConst.Apple:
      result = LogName.Apple;
      break;
    case _Router.RouterConst.Facebook:
      result = LogName.Facebook;
      break;
    case _Router.RouterConst.Google:
      result = LogName.Google;
      break;
    case _Router.RouterConst.CreatePasswordAndLinkToProfile:
      result = LogName.CreatePasswordAndLinkToProfile;
      break;

    default:
      console.assert(false, { message: 'Missing Log Name : ' + name });
      result = LogName.NotFound + ';' + name;
      break;
  }
  return result;
}

function getLogNameByPathname(pathName) {
  var result = void 0;
  if (validPathname(pathName)) {
    var path = getLastPathName(pathName.toLowerCase());
    result = getLogNameByRouterConst(path);
  } else {
    console.assert(false, { message: 'Missing Log Name : ' + pathName });
    result = LogName.NotFound + ';' + pathName;
  }

  return result;
}

function logRedirect(sessionId, auth, log, appInfo, loginClient, eventSelectedOption, destination, clientId, userDeviceId) {
  var destinationTime = new Date().getTime();
  var timeInSec = (destinationTime - log.srcTime) / 1000;
  var source = connectionMethodLogNamePage.includes(log.src) ? log.connectionMethod : log.src;
  var event = {
    logNavigationEvents: [{
      source: source,
      event: 'Navigation',
      destination: destination,
      productName: auth.productName,
      platform: auth.platform,
      deviceId: userDeviceId,
      eventTimestamp: destinationTime,
      thinkTimeSeconds: timeInSec,
      universalLoginFEVersion: appInfo.version,
      eventSelectedOption: eventSelectedOption,
      clientId: clientId }]
  };
  return loginClient.log.logNavigationEvent({ sessionId: sessionId, languageTag: auth.lang, logNavigationEvents: (0, _stringify2.default)(event) }, { responseContentType: 'application/json' }).then(function () {
    return loginClient;
  }).catch(function (error) {
    (0, _Error.logError)(error.statusText);
  });
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Logs.js
// module id = 46
// module chunks = 0